module.exports = __webpack_public_path__ + "static/media/rovaccinare.56aa22ba.jpg";